import { environmentHttpClient } from "../httpClient";

export type SendFeedbackModel = {
	message: string;
	canContactMe: boolean;
};

export function send(model: SendFeedbackModel, signal?: AbortSignal): Promise<void> {
	return environmentHttpClient.post<void>(
		"/Feedback/Send",
		model,
		{ signal }
	);
}
